import { Button, Checkbox, Modal } from "antd";
import "./LegalAgreePromptModal.css";

type Props = {
  open: boolean;
  title?: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
  confirmText?: string;
  children: React.ReactNode;
};

export function LegalAgreePromptModal(props: Props) {
  const {
    open,
    title = "请阅读并同意相关协议",
    checked,
    onCheckedChange,
    onCancel,
    onConfirm,
    confirmText = "同意并继续",
    children,
  } = props;

  return (
    <Modal
      className="legal-agree-prompt"
      title={null}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={400}
      centered
      destroyOnClose
      zIndex={1100}
    >
      <p className="legal-agree-prompt-title">{title}</p>
      <Checkbox
        className="legal-agree-prompt-check"
        checked={checked}
        onChange={(e) => onCheckedChange(e.target.checked)}
      >
        {children}
      </Checkbox>
      <div className="legal-agree-prompt-actions">
        <Button className="legal-agree-prompt-btn" onClick={onCancel}>
          取消
        </Button>
        <Button
          type="primary"
          className="legal-agree-prompt-btn legal-agree-prompt-btn--ok"
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
}
